import React, {useState} from 'react';
import {User} from "../../lib/stores/UserStore";
import Avatar from "../Avatar";
import Button from "@mui/material/Button";
import shadowClient from "../../lib/clients/shadow/shadowClient";
import PersonRemove from "@mui/icons-material/PersonRemove";
import Hardware from "@mui/icons-material/Hardware";
import {Card, CardActions, CardContent, CardMedia, SxProps, Typography} from "@mui/material";
import uiStore from "../../lib/stores/uiStore";
import shadowConfig from "../../config";
import {Alert} from "@mui/lab";
import {observer} from "mobx-react";

interface UserInfoProps {
    user: User
}

const UserInfo = React.forwardRef<HTMLDivElement, UserInfoProps>(({user}, ref) => {
    const [error, setError] = useState("");
    const userId = user.id;
    const isSelf = user.id === shadowClient.getClientUser()?.id;
    const room = shadowClient.roomStore.get(shadowClient.getJoinedRoomId());
    const roomId = room?.id;
    const clientUser = shadowClient.getClientUser()
    const isOwner = room && clientUser && room.owner_id === clientUser.id;
    const isAdmin = clientUser.isAdmin_();
    const userBanned = room?.banned.includes(userId);
    const memberIds = shadowClient.userStore.getUsersInRoom(room.id).map(user => user.id);

    let cardSx: SxProps;

    if (!uiStore.isMobile) {
        cardSx = {
            maxWidth: 345,
        }
    } else {
        cardSx = {
            width: "100%",
            borderRadius: 0,
        }
    }

    if (!user.data) {
        return null
    }

    return <Card
            ref={ref}
            sx={{
                position: "relative",
                ...cardSx,
            }}>
        <CardMedia
                component="img"
                alt="green iguana"
                height="148px"
                image={shadowConfig.apiUrl + '/static/images/' + user.data.banner}
        />
        <Avatar
                sx={{
                    position: "absolute",
                    left: "10px",
                    top: "10px"
                }}
                user={user} size={128}/>
        <CardContent>
            <Typography gutterBottom variant="h5" component="div">
                {user?.username}
            </Typography>
            <Typography variant="body2" color="text.secondary">
                {user.data.aboutMe}
            </Typography>
        </CardContent>

        {error ? <Alert sx={{margin: "0px 10px"}} variant={"outlined"} severity="error">{error}</Alert> : null}

        {(isOwner || isAdmin) && !isSelf && <CardActions
                sx={{
                    justifyContent: "flex-end",
                    padding: "10px",
                }}
        >
            <Button
                    size="small"
                    variant={"contained"}
                    component="label"
                    startIcon={<PersonRemove/>}
                    onClick={() => {
                        shadowClient.kickUser(roomId, user.id).then(() => setError("")).catch(e => setError(e.message));
                    }}>
                Kick
            </Button>

            <Button
                    size="small"
                    variant={"contained"}
                    component="label"
                    startIcon={<Hardware/>}
                    onClick={() => {
                        let banned = room.banned;

                        if (userBanned) {
                            banned = banned.filter(id => id !== userId);
                        } else {
                            banned.push(userId);
                        }

                        shadowClient.patchRoom(roomId, {banned}).then(() => setError("")).catch(e => setError(e.message));

                        if (memberIds.includes(user.id)) {
                            shadowClient.kickUser(roomId, user.id).then(() => setError("")).catch(e => setError(e.message));
                        }

                    }}>
                {!userBanned ? 'Ban' : 'Unban'}
            </Button>
        </CardActions>}
    </Card>
});

export default observer(UserInfo);
